import { RootState } from '@store';
import { DocumentState } from '@store/reducers/document.reducer';
import { statements, StatementState } from '@store/reducers/statement.reducer';
import { Statements, Documents } from '@types';
import { isEmpty, size } from 'lodash';
import { createSelector } from 'reselect';

export const documentSlice = (state: RootState) => state.doc || '';
export const selectDocUrl = createSelector([documentSlice], (slice: DocumentState): string => slice.documentUrl);

export const statementSlice = (state: RootState) => state.statement || statements;

export const selectstatements = createSelector([statementSlice], (slice: StatementState): Statements => slice.statements);

export const selectStatementsData = createSelector([selectstatements], (data: any) => {
    if (!isEmpty(data)) {
        return data?.documents;
    }
});
export const selectMonthlyStatement = createSelector([selectStatementsData], (documents: Documents[]): Documents[] => {
    if (!isEmpty(documents)) {
        const stateMent = documents.filter(document => document?.nameUid === '2285' || document?.nameUid === '2654');
        return size(stateMent) > 0 ? stateMent : null;
    }
});

export const selectTaxDocument = createSelector([selectStatementsData], (documents: Documents[]): Documents[] => {
    if (!isEmpty(documents)) {
        const taxDoc = documents.filter(document => document?.nameUid === '2278');
        return size(taxDoc) > 0 ? taxDoc : null;
    }
});
export const selectEscrowAnalysisDocument = createSelector([selectStatementsData], (documents: Documents[]): Documents[] => {
    if (!isEmpty(documents)) {
        const taxDoc = documents.filter(document => document?.nameUid === '2282');
        return size(taxDoc) > 0 ? taxDoc : null;
    }
});

export const selectLenderLoanNumber = createSelector(statementSlice, (slice: StatementState) => slice.lenderLoan);
export const selectLenderDocuments = createSelector(statementSlice, (slice: StatementState) => slice.documents);
export const selectStatementError = createSelector(statementSlice, (slice: StatementState) => slice.statements.errorDetails);
export const selectStatementLoading = createSelector(statementSlice, (slice: StatementState) => slice.loading);
